var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaperPlane = function SvgIconPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.102 2.277a1.75 1.75 0 0 1 2.418.658l.002.003 8.869 15.835a1.75 1.75 0 0 1-2.122 2.493l-8.278-2.95-8.279 2.95a1.75 1.75 0 0 1-2.122-2.493l.003-.006 8.866-15.83.002-.002c.151-.272.372-.5.64-.658m.889 2.02 8.324 14.863-7.324-2.612V11.25a1 1 0 0 0-2 0v5.298L3.666 19.16zM3.038 19.384l.001-.001z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPaperPlane;